/**
 * Infinite load posts
 */
export function infiniteLoadPosts(wrapper) {
    let $wrapper = $(wrapper);
    let wrapperId = $wrapper.attr('id');

    if (!wrapperId) {
        return;
    }

    let wrapperState = window.growtype_post['wrappers'][wrapperId] || {};

    if (wrapperState['infinite_load_observer']) {
        wrapperState['infinite_load_observer'].disconnect();
        wrapperState['infinite_load_observer'] = null;
    }

    if ($wrapper.find('.gp-actions-wrapper .btn-loadmore').length === 0) {
        return;
    }

    let params = $wrapper.attr('data-args');
    params = params ? JSON.parse(params) : {};

    if (!params['infinite_load_posts']) {
        return;
    }

    if (typeof window.IntersectionObserver === 'undefined') {
        return;
    }

    let sentinel = $wrapper.find('.gp-actions-wrapper').get(0);
    if (!sentinel) {
        return;
    }

    wrapperState['infinite_load_observer'] = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) {
            return;
        }

        let currentWrapper = $(document.getElementById(wrapperId));
        let currentState = window.growtype_post['wrappers'][wrapperId] || {};
        let btnLoadmore = currentWrapper.find('.gp-actions-wrapper .btn-loadmore');

        if (
            btnLoadmore.length > 0
            && !currentState['load_more_posts_btn_clicked']
            && !currentState['load_more_posts_request_in_flight']
        ) {
            btnLoadmore.trigger('click');
        }
    }, {
        rootMargin: '400px 0px',
        threshold: 0
    });

    wrapperState['infinite_load_observer'].observe(sentinel);
}
